export { menuVariables as menuItemIconVariables } from './menuVariables';
